module.exports = __webpack_public_path__ + "static/media/fullscreen.06d8f8ff.svg";